<template>
  <section class="feature-icons">
    <div class="main-container">
      <div class="feature-icon__wrapper">
        <div class="feature-icon__item">
          <div class="feature-icon__item-image">
            <img src="/static/img/geobeta/icons/Raid_Icon.svg" alt="" />
          </div>
          <div class="feature-icon__item-description">
            Raid dangerous areas!
          </div>
        </div>
        <div class="feature-icon__item">
          <div class="feature-icon__item-image">
            <img src="/static/img/geobeta/icons/Loot_Icon.svg" alt="" />
          </div>
          <div class="feature-icon__item-description">
            Loot supplies and weapons!
          </div>
        </div>
        <div class="feature-icon__item">
          <div class="feature-icon__item-image">
            <img src="/static/img/geobeta/icons/Lead_Icon.svg" alt="" />
          </div>
          <div class="feature-icon__item-description">
            Lead a camp of survivors!
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.feature-icon__wrapper {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  .feature-icon__item {
    flex: 1;
    max-width: 400px;
    margin: 15px 15px 0 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .feature-icon__item-image {
    }
    .feature-icon__item-description {
      margin-top: 10px;
      font-family: "Metron Book", sans-serif;
      font-size: 1.4em;
      font-weight: 700;
      line-height: 1.7;
      letter-spacing: 0.035em;
      text-align: center;
    }
  }
}
</style>
